import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { selectors as membershipSelectors } from '../../../../state/modules/memberships';
import { selectors as availabilityCodesSelectors } from '../../../../state/modules/availability-codes';
import { selectors as groupSelectors } from '../../../../state/modules/groups';
import { getCurrentUser } from '../../../../state/modules/current-user/operations';
import { selectCurrentUser } from '../../../../state/modules/current-user/selectors';
import AvailabilityChangeForm from '../../../schedule/availability/AvailabilityChangeForm';
import Loader from '../../../general/Loader';

const QuickAvailabilityChangeWidget = ({
  availabilityCodes,
  availabilityCodesLoaded,
  currentUser,
  currentUserPlannableOnCallStationMemberships,
  dashboardAPIManager,
  fetchCurrentUser,
  groupsLoading,
  width
}) => {
  useEffect(() => {
    dashboardAPIManager.fetchAvailabilityCodes();
    fetchCurrentUser();
  }, [dashboardAPIManager, fetchCurrentUser]);

  useEffect(() => {
    const groupIds = (currentUser?.memberships || []).map(membership => membership.group_id);
    if (groupIds.length === 0) return;
    dashboardAPIManager.fetchGroups({ ids: groupIds, onlyMissing: true });
  }, [dashboardAPIManager, currentUser]);

  if (groupsLoading) return <Loader />;

  return (
    <AvailabilityChangeForm
      availabilityCodes={availabilityCodes}
      availabilityCodesLoaded={availabilityCodesLoaded}
      currentUser={currentUser}
      horizontal={width > 2}
      currentUserPlannableStationMemberships={currentUserPlannableOnCallStationMemberships}
    />
  );
};

const mapStateToProps = state => ({
  availabilityCodesLoaded: availabilityCodesSelectors.initialLoadComplete(state),
  availabilityCodes: availabilityCodesSelectors.selectSchedulableAvailabilityCodes(state),
  groupsLoading: groupSelectors.loading(state),
  currentUser: selectCurrentUser(state),
  currentUserPlannableOnCallStationMemberships: membershipSelectors.currentUserPlannableOnCallStationMemberships(state)
});

const mapDispatchToProps = {
  fetchCurrentUser: getCurrentUser
};

Object.assign(QuickAvailabilityChangeWidget, {
  defaultSettings: {
    autoResizeHeight: true
  }
});

export default connect(mapStateToProps, mapDispatchToProps)(QuickAvailabilityChangeWidget);
